export const Theme = {
  HALL: 'hall',
  ACTION: 'action',
  AMSM: 'amsm',
  AFA: 'afa',
  CIC: 'cic',
  CLAB: 'clab',
  IGORSANDI: 'igorsandi',
  GUILHERMELAZARETTI: 'guilhermelazaretti',
  LARISSACIOATO: 'larissacioato',
  BIOACADEMIA: 'bioacademia',
  DCFIT: 'dcfit',
  EXOS: 'exos',
  GIBA: 'giba',
  OFRAGOZO: 'ofragozo',
  RENA: 'rena',
  THESTUDIO: 'thestudio',
  PEM: 'pem',
}
